import React, { useState, useEffect } from "react";
import { oneKlicks } from "../../../../SDK/oneclick";
import ImageShow from "../../../../Uitiles/ImageShow";
import DoctorPoster from "../../../../Uitiles/PosterFrame";
import { getuserdata } from "../../../../services/apiService";

const SelectFrame = () => {
    const [selectedFrame, setSelectedFrame] = useState(null);
    const [frames, setFrames] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterCategory, setFilterCategory] = useState('all');
    const [userdata, setUserdata] = useState(null);

    useEffect(() => {
        loadFrames();
        getUserdata();
      }, []);

    const getUserdata = async () => {
        const userdata = await getuserdata("full");
        setUserdata(userdata);
    }
    
      const loadFrames = async () => {
        setLoading(true);
        try {
    
          const tableSchema = "";
          const tableName = "postframes";
          const conditions = {
            status: "publish",
          }
          const orderBy = "id DESC";
          const search = "";
          const pagination = {
            page: 1,
            limit: 10,
          }
          const margedata = "";
          const frames = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata)
          console.log("frames",frames.data);
          // Replace with actual API call to get frames
          // const response = await apiService.getFrames();
          // setFrames(response.data);
          
          // Using mock data for now
          setTimeout(() => {
            setFrames(frames.data);
            setLoading(false);
          }, 1000);
        } catch (error) {
          console.error('Error loading frames:', error);
          setLoading(false);
        }
    };

    const filteredFrames = frames.filter(frame => {
        const matchesSearch = frame.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                             frame.description.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesCategory = filterCategory === 'all' || frame.category === filterCategory;
        return matchesSearch && matchesCategory;
    });

    const handleSelectFrame = (frame) => {
        setSelectedFrame(frame);
    };

    return (
        <div className="dc-dashboardbox dc-dashboardtabsholder dc-accountsettingholder" style={{ width: '100%', padding: '2% 4%', minHeight: '400px' }}>
            <div className="card--header mb-4">
                <h4 className="card-title" style={{ fontSize: '18px', fontWeight: '700', color: '#333' }}>Select Frame Template</h4>
                <p className="text-muted" style={{ fontSize: '13px', marginTop: '4px' }}>Choose a premium frame layout to display with your clinical details.</p>
            </div>

            {loading ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '300px', gap: '15px' }}>
                    <div className="spinner-border" role="status" style={{ color: '#f39c12', width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p style={{ color: '#888', fontSize: '14px', fontWeight: '500' }}>Loading premium layouts...</p>
                </div>
            ) : (
                <div className="frames-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '24px' }}>
                    {filteredFrames.length === 0 ? (
                        <div className="no-frames text-center py-5 w-100" style={{ gridColumn: '1 / -1' }}>
                            <i className="fa fa-image text-muted mb-3" style={{ fontSize: '48px', opacity: 0.3 }}></i>
                            <p style={{ color: '#888', fontSize: '14px' }}>No frames found. Upload your first frame!</p>
                        </div>
                    ) : (
                        filteredFrames.map(frame => {
                            const isSelected = selectedFrame?.id === frame.id;
                            return (
                                <div 
                                    key={frame.id} 
                                    className="frame-card"
                                    style={{
                                        border: isSelected ? '3px solid #f39c12' : '1px solid #e8e8e8',
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        position: 'relative',
                                        backgroundColor: '#fff',
                                        boxShadow: isSelected ? '0 12px 28px rgba(243, 156, 18, 0.18)' : '0 4px 12px rgba(0,0,0,0.05)',
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        transform: isSelected ? 'translateY(-4px)' : 'none',
                                        zIndex: isSelected ? 2 : 1
                                    }}
                                >
                                    <div className="frame-image" style={{ position: 'relative', overflow: 'hidden' }}>
                                        <DoctorPoster 
                                            frameImage={frame.imageUrl} 
                                            doctorImage={userdata?.profile_photo_url || ""}
                                            doctorName={userdata?.display_name || userdata?.name || "Dr. Professional"}
                                            specialization={userdata?.speciality || userdata?.subheading || userdata?.sub_heading || "Specialist"}
                                            phoneNumber={userdata?.mobile_number || userdata?.phone || ""}
                                            showPlaceholders={false}
                                            frameCategory={frame.category}
                                        />
                                        
                                        {/* Selected badge overlay */}
                                        {isSelected && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '12px',
                                                right: '12px',
                                                backgroundColor: '#2ecc71',
                                                color: '#fff',
                                                padding: '4px 10px',
                                                borderRadius: '20px',
                                                fontSize: '11px',
                                                fontWeight: 'bold',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px',
                                                boxShadow: '0 2px 8px rgba(46, 204, 113, 0.3)',
                                                zIndex: 10
                                            }}>
                                                <i className="fa fa-check-circle"></i> Selected
                                            </div>
                                        )}

                                        <div className="frame-overlay" style={{
                                            position: 'absolute',
                                            inset: 0,
                                            background: 'rgba(0,0,0,0.4)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            opacity: isSelected ? 1 : 0,
                                            transition: 'all 0.3s ease',
                                            borderRadius: '12px 12px 0 0',
                                            pointerEvents: 'none'
                                        }}>
                                            <button 
                                                className="btn-select" 
                                                onClick={() => handleSelectFrame(frame)} 
                                                style={{
                                                    background: isSelected ? "#2ecc71" : "#f39c12", 
                                                    color: "#ffffff", 
                                                    padding: "10px 20px", 
                                                    borderRadius: "50px", 
                                                    minWidth: "110px",
                                                    fontWeight: 'bold',
                                                    border: 'none',
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                    cursor: 'pointer',
                                                    pointerEvents: 'auto'
                                                }}
                                            >
                                                {isSelected ? "Selected ✓" : "Select"}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="frame-info" style={{ padding: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', margin: '0 0 6px 0', color: '#2c3e50' }}>{frame.title}</h3>
                                        <p style={{ fontSize: '12px', color: '#7f8c8d', margin: '0 0 12px 0', lineHeight: '1.4' }}>{frame.description}</p>
                                        <div className="frame-meta" style={{ display: 'flex', alignItems: 'center', justifyContent: 'between', flexWrap: 'wrap', gap: '8px', fontSize: '11px', borderTop: '1px solid #f2f4f8', paddingTop: '10px' }}>
                                            <span className="category" style={{ backgroundColor: '#edf2f7', color: '#4a5568', padding: '2px 8px', borderRadius: '4px', textTransform: 'capitalize' }}>{frame.category}</span>
                                            <span className="status" style={{ backgroundColor: '#e6fffa', color: '#319795', padding: '2px 8px', borderRadius: '4px', textTransform: 'capitalize' }}>{frame.status}</span>
                                            <span className="date" style={{ color: '#a0aec0', marginLeft: 'auto' }}>{frame.created_at ? frame.created_at.split('T')[0] : ''}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            )}
        </div>
    );
};

export default SelectFrame;
